/* Category banner carousel (blocks/ai_gen_block_7d1145b.liquid). Loaded once and
   shared by every instance; settings come from data-* attributes. Autoplay only
   runs while the carousel is on screen, so off-screen sliders cost nothing.
   Cards past the first screenful arrive in <template class="ai-cc-rest"> and are
   added (reveal) once the carousel is near the viewport or the user navigates. */
(function () {
  if (window.customElements.get('ai-cc-carousel')) return;

  class AiCcCarousel extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      var d = this.dataset, self = this;
      this.dPPV = parseInt(d.dppv, 10) || 4;
      this.mPPV = parseInt(d.mppv, 10) || 2;
      this.gap = parseInt(d.gap, 10) || 0;
      this.speed = (parseInt(d.speed, 10) || 3) * 1000;
      this.idx = 0;
      this.trk = this.querySelector('.ai-cc-trk');
      this.items = this.querySelectorAll('.ai-cc-prd');
      this.prevBtn = this.querySelector('.ai-cc-prev');
      this.nextBtn = this.querySelector('.ai-cc-next');
      if (!this.trk || !this.prevBtn || !this.nextBtn) return;

      this.prevBtn.addEventListener('click', function () { self.reveal(); self.go(-1); });
      this.nextBtn.addEventListener('click', function () { self.reveal(); self.go(1); });

      this.rest = this.querySelector('template.ai-cc-rest');
      if (this.rest) {
        if ('IntersectionObserver' in window) {
          this.restIO = new IntersectionObserver(function (entries) {
            if (entries.some(function (e) { return e.isIntersecting; })) self.reveal();
          }, { rootMargin: '400px 0px' });
          this.restIO.observe(this);
        } else {
          this.reveal();
        }
      }
      this.calc();
      window.addEventListener('resize', function () { self.calc(); });

      if (d.autoplay === 'true') {
        this.hovered = false;
        this.visible = !('IntersectionObserver' in window);
        this.addEventListener('mouseenter', function () { self.hovered = true; self.syncAuto(); });
        this.addEventListener('mouseleave', function () { self.hovered = false; self.syncAuto(); });
        document.addEventListener('visibilitychange', function () { self.syncAuto(); });
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            self.visible = entries[entries.length - 1].isIntersecting;
            self.syncAuto();
          }).observe(this);
        }
        this.syncAuto();
      }

      /* Show spinner on Add to Cart button while theme processes (delegated, so
         cards added later by reveal() are covered too) */
      this.addEventListener('click', function (e) {
        var btn = e.target.closest ? e.target.closest('.js_add_to_cart_button') : null;
        if (!btn || !self.contains(btn)) return;
        (function () {
          var textEl = btn.querySelector('.text');
          if (textEl) textEl.style.display = 'none';
          var spinner = document.createElement('span');
          spinner.className = 'ai-cc-spinner';
          btn.insertBefore(spinner, btn.firstChild);
          setTimeout(function () {
            var s = btn.querySelector('.ai-cc-spinner');
            if (s) s.remove();
            if (textEl) textEl.style.display = '';
          }, 5000);
        })();
      });
    }

    reveal() {
      var tpl = this.rest;
      if (!tpl) return;
      this.rest = null;
      if (this.restIO) { this.restIO.disconnect(); this.restIO = null; }
      tpl.parentNode.insertBefore(tpl.content, tpl);
      tpl.remove();
      this.items = this.querySelectorAll('.ai-cc-prd');
      this.calc();
      /* let the theme mark wishlist/compare state on the new cards */
      if (window.jQuery) window.jQuery(document.body).trigger('contentUpdated');
    }

    getPPV() { return window.innerWidth <= 768 ? this.mPPV : this.dPPV; }

    calc() {
      this.ppv = this.getPPV();
      this.max = Math.max(0, this.items.length - this.ppv);
      if (this.idx > this.max) this.idx = this.max;
      this.slide();
    }

    go(dir) { this.idx = Math.max(0, Math.min(this.max, this.idx + dir)); this.slide(); }

    slide() {
      if (!this.items.length) return;
      var w = this.items[0].offsetWidth + this.gap;
      this.trk.style.transform = 'translateX(-' + (this.idx * w) + 'px)';
      this.prevBtn.disabled = this.idx === 0;
      this.nextBtn.disabled = this.idx >= this.max;
    }

    syncAuto() {
      var run = this.visible && !this.hovered && !document.hidden, self = this;
      if (run && !this.autoTimer) {
        this.autoTimer = setInterval(function () {
          self.idx = self.idx >= self.max ? 0 : self.idx + 1;
          self.slide();
        }, this.speed);
      } else if (!run && this.autoTimer) {
        clearInterval(this.autoTimer);
        this.autoTimer = null;
      }
    }
  }

  window.customElements.define('ai-cc-carousel', AiCcCarousel);
})();
